import { Component } from '@angular/core';
import {AuthService} from '../auth.service';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {LdsUserService} from '../lib/services/lds-user.service';
import {WsChatService} from '../lib/lds-websocket-module/ws-chat/ws-chat.service';
import {WsPacketService} from '../lib/lds-websocket-module/ws-packet/ws-packet.service';
import {filter} from 'rxjs/operators';

export interface WebSocketPacket {
  direction: string;
  items: any[];
  senderId: string | number;
  transactionId: number;
  class: string;
  operation: string;
  version: number;
}
@Component({
    selector: 'ds-login-as',
    templateUrl: './login-as.component.html',
    styleUrls: ['./login-as.component.scss'],
    standalone: false
})

export class LoginAsComponent {

  message: string;
  loading: boolean;
  mfaRequired = false;
  mfaCode = '';
  user = {
    adminEmail: '',
    username: '',
    password: '',
    action: () => {
      if (this.user.password === '') {
        // TODO: set error message for no password
        this.message = 'No Password';
      } else {
        this.performLogin();
      }
    }
  };

  constructor(private authService: AuthService, private router: Router, private ldsUser: LdsUserService, private route: ActivatedRoute, private wsChatService: WsChatService, private wsPacketService: WsPacketService) {
  }

  performLogin(): void {
    const mfaCodeToSend = this.mfaRequired ? this.mfaCode : undefined;

    this.authService.loginAs(this.user.adminEmail, this.user.username, this.user.password, mfaCodeToSend).subscribe((resp) => {
      console.log(resp);
      this.mfaRequired = false;
      this.mfaCode = '';
      this.message = '';
      this.authService.saveUserDetail(resp.user);
      this.initiateWs(resp.user);
      this.wsChatService._checkAuth()
        .then(() => {
          let wsPacket = this.wsPacketService.getPacket('user', 'read', {});
          this.wsChatService._sendMsg(wsPacket)
            .then((userSettings: WebSocketPacket) => {
              const settings = userSettings.items[0].payload;
              const license = settings.licenses && settings.licenses.v5.license;
              if (!license) {
                this.message = 'My Lightwave Energy Dashboard is available exclusively to Lightwave PLUS members.';
                this.wsChatService.close();
                return;
              }
              this.authService.isLoggedIn = true;
              this.ldsUser.userDetail = resp.user;
              this.router.navigate(['/data-studio/energy/overview'], {relativeTo: this.route});
            });
        });
    },
    err => {
      if (err.status === 401 && err.error?.error === 'mfa_required') {
        this.mfaRequired = true;
        this.mfaCode = '';
        this.message = 'Please enter your 6-digit authentication code';
      } else if (err.status === 401 && this.mfaRequired) {
        this.message = 'Invalid authentication code. Please try again.';
        this.mfaCode = '';
      } else {
        this.message = 'failed to login';
      }
      console.log(err);
    });
  }

  setMessage(): void {
    this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
  }

  ngOnInit() {
    this.router.events.pipe(filter((d) => d instanceof NavigationStart)).subscribe((event) => {
      this.loading = true;
    });
  }

  initiateWs(usrInfo) {
    if (this.wsChatService.alreadyAuthed()) {
      this.wsChatService.initiateNoAuth(usrInfo.user._id);
    } else {
      this.wsChatService.initiate(usrInfo.user._id);
    }
  }

}
